enum SearchStatus {
  Category,
  Generic,
  Unactive,
  ReadyForSearch,
  NoCategory,
}

export default SearchStatus
